export const BUY = 0
export const SELL = 1

export const MARKET = 0
export const LIMIT = 1
export const IOC = 2
export const FOK = 3
export const MOC = 4

export const WITHDRAW = 0
export const DEPOSIT = 1
export const MINT = 2
export const BURN = 3

export const START_BLOCK = 28731619